import { Linkedin, Instagram, Facebook, MessageCircle } from "lucide-react";

export const SOCIALS = [
    {
        name: "LinkedIn",
        href: "https://www.linkedin.com/company/pixelgrokmedia/",
        Icon: Linkedin,
        testid: "social-linkedin",
    },
    {
        name: "Instagram",
        href: "https://www.instagram.com/pixelgrokmedia/",
        Icon: Instagram,
        testid: "social-instagram",
    },
    {
        name: "Facebook",
        href: "https://www.facebook.com/profile.php?id=61589082766238",
        Icon: Facebook,
        testid: "social-facebook",
    },
    {
        name: "WhatsApp",
        href: "https://wa.me/message/TNOQZLHDIQ4LI1",
        Icon: MessageCircle,
        testid: "social-whatsapp",
    },
];

/**
 * SocialIcons — minimal icon row.
 * size: "sm" (28px) for nav/inline | "md" (40px) for footer
 * variant: "ghost" (transparent w/ border) | "solid" (filled red on hover)
 */
export default function SocialIcons({
    size = "md",
    variant = "ghost",
    className = "",
}) {
    const dims =
        size === "sm" ? "h-9 w-9" : size === "lg" ? "h-12 w-12" : "h-11 w-11";
    const icon = size === "sm" ? 14 : size === "lg" ? 20 : 17;
    const base =
        variant === "solid"
            ? "border border-[#26262a] bg-[#0a0a0c] hover:bg-[#e6192b] hover:border-[#e6192b]"
            : "border border-[#26262a] hover:border-[#e6192b] hover:text-[#e6192b]";
    return (
        <ul
            data-testid="social-icons"
            className={`flex items-center gap-2 ${className}`}
        >
            {SOCIALS.map(({ name, href, Icon, testid }) => (
                <li key={name}>
                    <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={name}
                        title={name}
                        data-testid={testid}
                        className={`group ${dims} inline-flex items-center justify-center rounded-full text-[#cfcfd6] transition-all duration-300 hover:scale-[1.06] ${base}`}
                    >
                        <Icon size={icon} strokeWidth={1.5} />
                    </a>
                </li>
            ))}
        </ul>
    );
}
